import { API } from "apis";
import axios from "axios";
import AppCaptcha from "components/common/AppCaptcha";
// import TermsOfServiceContents from "components/public/TermsOfServiceContents";
import TopHeader from "components/top/TopHeader";
import { ContextModel } from "models";
import qs from "query-string";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useOutletContext } from "react-router-dom";
import { Utils } from "utils";

const TERMS_SERVICES = [
  {
    id: "terms_1",
    label: "トラスト・リンケージ利用規約を確認する",
    url: "https://trustlinkage.jp/pdf/trustlinkage_terms.pdf",
    checked: false,
    countClick: 0
  },
  {
    id: "terms_2",
    label: "商取引基本規約を確認する",
    url: "https://trustlinkage.jp/pdf/trustlinkage_basic_sale_and_purchase_agreement.pdf",
    checked: false,
    countClick: 0
  },
  {
    id: "terms_3",
    label: "重要事項説明書を確認する",
    url: "https://trustlinkage.jp/pdf/trustlinkage_important_matters.pdf",
    checked: false,
    countClick: 0
  },
  {
    id: "terms_4",
    label: "「早期資金化」サービス利用規約、サービス概要を確認する",
    url: "https://trustlinkage.jp/pdf/trustlinkage_factoring.pdf",
    checked: false,
    countClick: 0
  },
  {
    id: "terms_5",
    label: "上記、4項目に関して同意する",
    url: "",
    checked: false,
    countClick: 0
  },
];
const TermsOfServicePage: React.FC = () => {
  const location = useLocation();

  const query = qs.parse(location.search);
  const pre_entry_id = (query.pre_entry_id as string) ?? "";

  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const [token, setToken] = React.useState(0);
  const [isValidCaptcha, setIsValidCaptcha] = React.useState(false);
  const [termsService, setTermsService] = React.useState(TERMS_SERVICES as any[]);
  const [isErrorTerms, setIsErrorTerms] = React.useState(false);

  const isDisableButton = React.useMemo(() => {
    return !(termsService.every((item: any) => !!item.checked) && isValidCaptcha);
  }, [termsService, isValidCaptcha]);

  const onChecked = (checked: boolean, index: number, updateCount?: boolean) => {
    const tmp = [...termsService];
    tmp[index].checked = checked;
    if(updateCount) {
      tmp[index].countClick++;
    }

    if(!checked && tmp[index].id !== "terms_5") {
      const indexTerms5 = tmp.findIndex((item) => item.id === "terms_5");
      tmp[indexTerms5] = { ...tmp[indexTerms5], checked: false };
    }

    setTermsService(tmp);
  }

  const onClickCheckbox = (checked: boolean, index: number) => {
    const refTerm = termsService[index];

    const isValid = termsService.filter((t: any) => t.id !== "terms_5").some((item: any) => !item.checked);
    if (refTerm.id === "terms_5" && isValid) {
      setIsErrorTerms(true);
      return;
    };

    setIsErrorTerms(false);

    if(checked &&refTerm.countClick === 0) {
      onChecked(checked, index, true);
      if(refTerm.id === "terms_5") return;
      window.open(refTerm.url);
    } else {
      onChecked(checked, index)
    }
  }

  const onClickLabel = (checked: boolean, index: number) => {
    if(termsService[index].id === "terms_5") {
      onClickCheckbox(!checked, index);
      return;
    };
    if(!checked) {
      onChecked(!checked, index, true);
    }
    window.open(termsService[index].url);
  }

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      ctx.loading.setState(false);
      try {
        const response = await API.Auth.preAccessTokenCheck(pre_entry_id);
        console.log(response);
        setToken(response.data.token_category);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!token) {
    return <></>;
  }

  return (
    <div>
      <Helmet>
        <title>利用規約</title>
      </Helmet>
      <TopHeader />
      <div className="w-full mx-auto py-8 px-16" style={{ maxWidth: "1920px" }}>
        <div>
          <div className="border-b text-2xl font-bold">トラスト・リンケージとは</div>
          <div className="my-4">
            トラスト・リンケージは事業を営む上で直面する「悩み」を解決するために開発された事業者向けデジタル商社サービスです。{" "}
          </div>
          <div className="my-4">
            トラスト「信用・信頼」、リンケージ「つながり・連鎖」の意味を持つように、加入事業者の皆さまへ
            <a href={process.env.REACT_APP_SHIKINGURI_URL} className="text-jhk-blue hover:underline cursor-pointer" target="_blank" rel="noreferrer">
              ①資金繰り支援
            </a>
            、②信用補完、
            <a href={process.env.REACT_APP_DX_URL} className="text-jhk-blue hover:underline cursor-pointer" target="_blank" rel="noopener noreferrer">
              ③DX化支援
            </a>
            、
            <a href={process.env.REACT_APP_BUSINESSMATCHING_URL} className="text-jhk-blue hover:underline cursor-pointer" target="_blank" rel="noopener noreferrer">
              ④ビジネスマッチング
            </a>
            と商社機能である4つのメリットを実現しました。
          </div>
          <div className="my-4">
            また2023年10月よりインボイス制度にも対応しており、商取引管理、資金繰りまでを含め、経営の見える化が可能です。{" "}
          </div>
          <div className="my-4">
            城北信用金庫グループとして、地域企業へ寄り添い、新たなビジネスソリューションとして、「トラスト・リンケージ」をご提供します。
          </div>
        </div>

        <div className="mt-28">
          <AppCaptcha onSuccess={setIsValidCaptcha} />
          <div className="my-4 flex flex-col mx-auto max-w-max">
            {termsService.map((item: any, index: number) => (
              <div key={item.id}>
                <input id={item.id} type="checkbox" checked={!!item.checked} onChange={(e: any) => onClickCheckbox(e.target.checked, index)}/>
                <span className="ml-2 font-medium cursor-pointer" onClick={() => onClickLabel(item?.checked, index)}>
                  {item.label}
                </span>
              </div>
            ))}
            {isErrorTerms && <p className="text-sm ml-7 text-red-500">上記、４項目を同意して下さい。</p>}
          </div>
        </div>

        {token === 1 && (
          // 1: 招待されて登録 : 利用規約画面から既存取引先画面に遷移する
          <div className="flex justify-center m-8">
            <Link to={`/existing-clients/?pre_entry_id=${pre_entry_id}`}>
              <button disabled={isDisableButton} className= {`${isDisableButton ? 'secondary-disabled px-4 py-2':'primary px-4 py-2'}`}>
                登録する
              </button>
            </Link>
          </div>
        )}
        {token === 2 && (
          // 2: 招待無しで登録 : 利用規約画面から会社登録申請画面に遷移する
          <div className="flex justify-center m-8">
            <Link to={`/company-entry-apply/?pre_entry_id=${pre_entry_id}`}>
              <button disabled={isDisableButton} className= {`${isDisableButton ? 'secondary-disabled px-4 py-2':'primary px-4 py-2'}`}>
                登録する
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsOfServicePage;
